function errorFlash(ref) {
    if (!ref.current.style.animation) {
        ref.current.style.animation = "error-flash-light .5s 2"
        setTimeout(() => {
            ref.current.style.animation = ''
        }, 1000)
    }
}

export default errorFlash